import React, { useEffect, useState } from "react";
import Form from "../../../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import FormSubmitButton from "../../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import { PRODUCT_COLLECTIONS_API } from "../../../../../../Utilities/APIs/APIs";
import slugify from "react-slugify";
import Dropdown from "../../../../../Partials/Layouts/dropdown/Dropdown";
import SwitchInput from "../../../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput";

function UpdateProductCollections({
  targetID,
  triggerFetch,
  setShowUpdateForm,
}) {
  const axiosInstance = useAxiosInstance();

  const [name, setName] = useState("");

  const [isActive, setIsActive] = useState(false);
  console.log(isActive, 'isActive');
  // const toggleDropdown = () => {
  //   setDropdown(!dropdown);
  // };

  useEffect(() => {
    async function fetchAndSetSingleProductCollections() {
      const { data } = await axiosInstance.get(
        PRODUCT_COLLECTIONS_API + "getSingleProductCollection/" + targetID
      );
      setName(data?.name);
      setIsActive(data?.isActive);
    }
    fetchAndSetSingleProductCollections();
  }, [targetID, axiosInstance]);

  async function handleSubmit(e) {
    e.preventDefault();
    const itemData = new FormData();

    itemData.append("name", name);
    itemData.append("slug", slugify(name));
    itemData.append("isActive", isActive);

    const response = await axiosInstance.patch(
      PRODUCT_COLLECTIONS_API + "updateProductCollections/" + targetID,
      itemData
    );
    if (response) {
      console.log("response:", response);
      triggerFetch();
      setShowUpdateForm(false);
    }
  }

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div>
          <ShortTextInput
            label={`Product Collection name`}
            value={name}
            placeholder={`Category Name`}
            setState={setName}
          />
          <ShortTextInput
            label={`Slug`}
            value={slugify(name)}
            placeholder={`Enter Slug`}
            disabled
          />
          {/* <Dropdown /> */}
          <SwitchInput
            label={`IsActive`}
            toggleSwitch={() => setIsActive((prevState) => !prevState)}
            checked={isActive}
          />
        </div>
        <FormSubmitButton text="Submit" />
      </Form>
    </div>
  );
}

export default UpdateProductCollections;
